module.exports = __webpack_public_path__ + "img/zc.2c358b0f.png";